import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Warning } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function CookbookDeleteDialog({ cookbook, onClose, onDeleted }) {
  const [notify, setNotify] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (cookbook) setNotify(true); }, [cookbook]);

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.delete(`/admin/cookbooks/${cookbook.cookbook_id}?notify=${notify}`);
      toast.success(`Deleted cookbook and ${data.deleted_recipes} recipe${data.deleted_recipes === 1 ? "" : "s"}`);
      onDeleted();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Delete failed");
    } finally { setBusy(false); }
  };

  const n = cookbook?.recipe_count || 0;
  return (
    <Dialog open={!!cookbook} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="admin-cookbook-delete-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700"><Warning size={20} weight="fill" /> Delete cookbook?</DialogTitle>
          <DialogDescription data-testid="admin-cookbook-delete-warning">
            This permanently deletes <b>{cookbook?.title || "Untitled"}</b> and the {n} recipe{n === 1 ? "" : "s"} stored in it, including their photos, scans and audio. This cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <label className="flex items-center gap-2 text-sm text-rf-ink">
          <input type="checkbox" data-testid="admin-cookbook-delete-notify" checked={notify} onChange={(e) => setNotify(e.target.checked)} className="w-4 h-4" />
          Email the owner ({cookbook?.owner_email || "—"})
        </label>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} data-testid="admin-cookbook-delete-cancel" className="btn-outline-ink !py-2 !px-4 text-sm">Cancel</button>
          <button type="button" onClick={confirm} disabled={busy} data-testid="admin-cookbook-delete-confirm" className="btn-amber !bg-red-600 hover:!bg-red-700 !text-white !py-2 !px-4 text-sm">{busy ? "Deleting…" : "Delete permanently"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
